import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 17",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.058 10.256a2.92 2.92 0 0 0-2.297 1.127L5.768 8.829c.065-.244.112-.496.112-.761 0-.289-.056-.56-.134-.825l4.972-2.542a2.921 2.921 0 0 0 2.34 1.178 2.94 2.94 0 1 0 0-5.879 2.94 2.94 0 0 0-2.939 2.94c0 .265.047.518.113.762L5.24 6.256a2.927 2.927 0 0 0-2.3-1.129A2.94 2.94 0 0 0 0 8.067a2.939 2.939 0 0 0 2.94 2.941c.96 0 1.805-.467 2.343-1.18l4.97 2.542a2.903 2.903 0 0 0-.135.827 2.94 2.94 0 1 0 2.94-2.941Z" }, null, -1)
  ]))]))
}
export default { render };